import React, { useState } from "react";
import {
  CuidaUploadOutline,
  MageFilter,
  MajesticonsTable,
  MaterialSymbolsSearchRounded,
} from "../../assets/icons/LayoutIcon";
import ExportDialogBox from "./ExportDialogBox";
import GridDialogBox from "./GridDialogBox";
import SubFilterComponent from "./SubFilterComponent";

const SearchExportFilterComponent = ({
  exportFileName,
  onSearch,
  onExport,
  searchPlaceholder = "Search here..",
  tablefields,
  selectedHeaders,
  onHeadersChange,
  ExportOptionVisisbility = true,
  FilterOptionVisisbility = true,
  GridIconVisibility = true,
  fields,
  onApply,
  onReset,
  exportData,
  getComputedExportData,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [openExportDialogBox, setOpenExportDialogBox] = useState(false);
  const [openGridDialogBox, setOpenGridDialogBox] = useState(false);
  const [openFilterDialogBox, setOpenFilterDialogBox] = useState(false);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className={`justify-between block sm:flex gap-2 ${(ExportOptionVisisbility  ) ? "block":"flex items-center max-h-11" } `}>
      <div className="flex justify-between items-center mb-2 sm:mb-0">
        {/* Search Input */}
        <div className="flex justify-between items-center gap-3 w-full lg:w-1/3">
          <div className="flex items-center border px-2 rounded-md border-gray-300 gap-2 min-h-10 flex-grow">
            <MaterialSymbolsSearchRounded className="text-gray-400 h-6 w-6" />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-full rounded pl-2 pr-5 text-sm font-normal text-gray-600 focus:outline-none focus:ring:none"
              placeholder={searchPlaceholder}
            />
          </div>

          {FilterOptionVisisbility && (
            <div className="block lg:hidden items-center border px-2 rounded-md border-gray-300 ">
              <button onClick={() => setOpenFilterDialogBox(true)}>
                <MageFilter className="text-gray-600 items-center w-6 h-6 mt-1 " />
              </button>
            </div>
          )}
        </div>
        {/* Filter */}
        {FilterOptionVisisbility && (
          <SubFilterComponent
            fields={fields}
            onApply={onApply}
            onReset={onReset}
            openFilter={openFilterDialogBox}
            handleClose={() => {
              setOpenFilterDialogBox(false);
            }}
          />
        )}
      </div>

      {/* Action Icons */}
      <div className={`flex sm:justify-end  justify-between gap-3 ${ExportOptionVisisbility ? "mt-0 " :"-mt-1 max-h-9 items-center"} `}>
        {/* Table View Icon */}
        {GridIconVisibility && (
          <>
            <div
              className="px-2.5 pb-1.5 pt-2 border border-gray-200 rounded-md cursor-pointer items-center"
              onClick={() => {
                setOpenGridDialogBox(true);
              }}
            >
              <MajesticonsTable className="text-gray-700 h-6 w-6 items-center" />
            </div>
          </>
        )}
        {/* Export Icon */}
        {ExportOptionVisisbility && (
          <div
            className="px-2.5 py-1 sm:py-1.5 border border-gray-300 rounded-md flex items-center cursor-pointer"
            onClick={onExport}
          >
            <button
              className="flex items-center"
              onClick={() => {
                setOpenExportDialogBox(true);
              }}
            >
              <CuidaUploadOutline className="text-gray-600 mr-1 " />
              <h1 className="text-sm text-gray-600">Export</h1>
            </button>
          </div>
        )}
      </div>
      {openExportDialogBox && (
        <ExportDialogBox
          handleCancel={() => setOpenExportDialogBox(false)}
          fileName={exportFileName}
          data={exportData}
          onExport={onExport}
          getComputedExportData={getComputedExportData}
        />
      )}
      {openGridDialogBox && (
        <GridDialogBox
          handleClose={() => setOpenGridDialogBox(false)}
          selectedHeaders={selectedHeaders}
          tablefields={tablefields}
          onHeadersChange={onHeadersChange}
        />
      )}
    </div>
  );
};

export default SearchExportFilterComponent;
